export enum OnboardingMethod {
  Default = 'default',
  KYC = 'kyc',
  KYCError = 'kyc-error',
  KYCInit = 'kyc-init',
}
